"use strict";
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    /** Contains types and functions to interact with Skype for Business Online. */
    var skypeInteraction;
    (function (skypeInteraction) {
        /** Contains constants required to authenticate with Skype. */
        var Constants;
        (function (Constants) {
            /**
             * The pre-production origin URL for Skype authentication
             * @internal
             */
            Constants.PreProdOrigin = "https://webdir.tip.lync.com/autodiscover/autodiscoverservice.svc/root";
            /**
             * The production origin URL for Skype authentication
             * @internal
             */
            Constants.ProdOrigin = "https://webdir.online.lync.com/autodiscover/autodiscoverservice.svc/root";
            /**
             * The pre-production API key
             * @internal
             */
            // tslint:disable-next-line:max-line-length
            // [SuppressMessage("Microsoft.Security", "CS002:SecretInNextLine", Justification="Used to mark traffic as coming from ERP, not as a secret (any GUID can be used as long as it's the same for the entire product)")]
            Constants.PreProdApiKey = "a42fcebd-5b43-4b89-a065-74450fb91255";
            /**
             * The production API key
             * @internal
             */
            // tslint:disable-next-line:max-line-length
            // [SuppressMessage("Microsoft.Security", "CS002:SecretInNextLine", Justification="Used to mark traffic as coming from ERP, not as a secret (any GUID can be used as long as it's the same for the entire product)")]
            Constants.ProdApiKey = "b66066f1-27cb-494d-8b90-e97f99828237";
            /**
             * The Dynamics 365 Finance and Operations client ID
             * @internal
             */
            Constants.ClientId = "00000015-0000-0000-c000-000000000000";
            /**
             * The domain of pre-production user emails
             * @internal
             */
            Constants.PreProdDomain = "ccsctp.net";
            /**
             * The pre-production Skype authentication redirect URL
             * @internal
             */
            Constants.PreProdAuthUrl = "https://login.windows-ppe.net";
            /**
             * The production Skype authentication redirect URL
             * @internal
             */
            Constants.ProdAuthUrl = "https://login.microsoftonline.com";
            /**
             * The pre-production Skype resource
             * @internal
             */
            Constants.PreProdResource = "https://webdir.tip.lync.com";
            /**
             * The production Skype resource
             * @internal
             */
            Constants.ProdResource = "https://webdir.online.lync.com";
            /**
             * The production Skype CDN location
             * @internal
             */
            Constants.SkypeCDNUrl = "https://swx.cdn.skype.com/shared/v/1.2.15/SkypeBootstrap.min.js";
        })(Constants = skypeInteraction.Constants || (skypeInteraction.Constants = {}));
        /**
         * The object used to authenticate the page with Skype
         * @internal
         */
        skypeInteraction.AuthenticationParams = {
            auth: null,
            client_id: null,
            cors: true,
            origins: [Constants.ProdOrigin],
            version: "Dynamics/1.0.0",
        };
        /**
         * Represents the types of authentication status
         * @internal
         */
        var AuthenticationStatusType;
        (function (AuthenticationStatusType) {
            AuthenticationStatusType["Unknown"] = "Unknown";
            AuthenticationStatusType["Authenticating"] = "Authenticating";
            AuthenticationStatusType["Authenticated"] = "Authenticated";
            AuthenticationStatusType["Failed"] = "Failed";
        })(AuthenticationStatusType = skypeInteraction.AuthenticationStatusType || (skypeInteraction.AuthenticationStatusType = {}));
        /**
         * Represents the types of presence
         * @internal
         */
        var PresenceType;
        (function (PresenceType) {
            PresenceType["Online"] = "Online";
            PresenceType["Offline"] = "Offline";
            PresenceType["Away"] = "Away";
            PresenceType["Idle"] = "Away";
            PresenceType["BeRightBack"] = "BeRightBack";
            PresenceType["Busy"] = "Busy";
            PresenceType["DoNotDisturb"] = "DoNotDisturb";
            PresenceType["Unknown"] = "Unknown";
        })(PresenceType = skypeInteraction.PresenceType || (skypeInteraction.PresenceType = {}));
        /**
         * The application instance used to interact with Skype
         * @internal
         */
        skypeInteraction.client = undefined;
        /**
         * The application instance used to interact with Skype
         * @internal
         */
        skypeInteraction.authStatus = AuthenticationStatusType.Unknown;
        /**
         * Maps a string SIP address to a PresenceSubscription instance.
         * @internal
         */
        skypeInteraction.subscriptionMap = {};
        /**
         * Maps a string SIP address to a $dyn.controls.BaseInput instance, representing a registerControl to be made in the future.
         * This map is used to store registration information while the form is in edit mode, as all controls are destroyed outside of view mode.
         * @internal
         */
        skypeInteraction.cachedRegistrationMap = {};
        /**
         * Creates an event handler to close the qtip and re-focus the input control.
         * @internal
         * @param qtip The qtip to close.
         * @param inputControl The input control to focus.
         * @returns The created event handler.
         */
        function createQtipCloseHandler(qtip, inputControl) {
            return function () {
                qtip.toggle();
                inputControl.$inputElement.focus();
            };
        }
        skypeInteraction.createQtipCloseHandler = createQtipCloseHandler;
        /**
         * Represents a text input control with presence enabled
         * @internal
         */
        var PresenceControl = /** @class */ (function () {
            /**
             * @param inputControl The text input control
             * @param presenceElement The colored presence element
             * @param presenceContainer The presence container
             * @param qtip The qtip associated with the control
             * @param qtipControl The React control inside the qtip
             */
            function PresenceControl(inputControl, presenceElement, presenceContainer, qtip, qtipControl) {
                this.inputControl = inputControl;
                this.presenceElement = presenceElement;
                this.presenceContainer = presenceContainer;
                this.qtip = qtip;
                this.qtipControl = qtipControl;
                // constructor
            }
            return PresenceControl;
        }());
        skypeInteraction.PresenceControl = PresenceControl;
        /**
         * Represents a subscription to a SIP address
         * @internal
         */
        var PresenceSubscription = /** @class */ (function () {
            /**
             * @param sipAddress The SIP address of the control.
             */
            function PresenceSubscription(sipAddress) {
                var _this = this;
                /**
                 * Updates the displayed presence on all subscribed controls. Valid presence values are "Online", "Offline", "Away", "Idle", "BeRightBack", "Busy", "DoNotDisturb", and "Unknown".
                 * @internal
                 * @param presence The updated presence value.
                 */
                this.onPresenceChanged = function (presence) {
                    var presenceClassToRemove = "skype-hasPresence" + _this.presenceValue;
                    _this.presenceValue = presence in PresenceType ? presence : PresenceType.Unknown;
                    var presenceClassToAdd = "skype-hasPresence" + _this.presenceValue;
                    // Remove the old presence class and add the new
                    _this.controls.forEach(function (control) {
                        control.presenceElement.removeClass(presenceClassToRemove);
                        $dyn.setValue(control.inputControl, "Presence", _this.presenceValue);
                        control.inputControl.$cachedElement.addClass("skype-presenceInput");
                        control.presenceElement.addClass(presenceClassToAdd);
                        if (control.qtip && control.qtipControl) {
                            // Re-render the qtip control with the new presence value
                            // The getQtipContent() function was created specifically for this call, as it prevents errors when qtip are nested
                            control.qtipControl = React && ReactDOM.render(React.createElement($dyn.DynReact.UI.SkypeContactCard, {
                                Authenticated: skypeInteraction.authStatus === AuthenticationStatusType.Authenticated,
                                AvatarUrl: _this.avatarUrl,
                                ContactName: _this.contactName,
                                ContactPhone: _this.contactPhone,
                                ContactTitle: _this.contactTitle,
                                PresenceValue: _this.presenceValue,
                                SipAddress: _this.sipAddress,
                                ToggleQtip: createQtipCloseHandler(control.qtip, control.inputControl),
                            }), getQtipContent(control.qtip)[0]);
                        }
                    });
                };
                /**
                 * Refreshes the displayed presence on all subscribed controls
                 * @internal
                 */
                this.refresh = function () {
                    _this.onPresenceChanged(_this.presenceValue);
                };
                /**
                 * Replaces the controls' sign-in qtip with a sip address link.
                 * @internal
                 */
                this.registerSuccessfulSignIn = function () {
                    _this.controls.forEach(function (control) {
                        if (control.qtip && control.qtipControl) {
                            control.qtipControl = React && ReactDOM.render(React.createElement($dyn.DynReact.UI.SkypeContactCard, {
                                Authenticated: true,
                                PresenceValue: _this.presenceValue,
                                SipAddress: _this.sipAddress,
                                ToggleQtip: createQtipCloseHandler(control.qtip, control.inputControl),
                            }), getQtipContent(control.qtip)[0]);
                        }
                    });
                };
                /**
                 * Initializes the contact card DOM elements with the set contact information
                 * @internal
                 */
                this.completeInitialization = function () {
                    _this.controls.forEach(function (control) {
                        if (control.qtip && control.qtipControl) {
                            control.qtipControl = React && ReactDOM.render(React.createElement($dyn.DynReact.UI.SkypeContactCard, {
                                Authenticated: true,
                                AvatarUrl: _this.avatarUrl,
                                ContactName: _this.contactName,
                                ContactPhone: _this.contactPhone,
                                ContactTitle: _this.contactTitle,
                                PresenceValue: _this.presenceValue,
                                SipAddress: _this.sipAddress,
                                ToggleQtip: createQtipCloseHandler(control.qtip, control.inputControl),
                            }), getQtipContent(control.qtip)[0]);
                        }
                    });
                };
                this.sipAddress = sipAddress;
                this.controls = [];
            }
            return PresenceSubscription;
        }());
        skypeInteraction.PresenceSubscription = PresenceSubscription;
        PresenceSubscription.prototype.presenceValue = PresenceType.Unknown;
        $(function initializeSkypeOnLoad() {
            var queryValues = $dyn.util.parseQueryString(window.location.href);
            // If window.location.hash exists, we've been redirected after authenticating with Skype
            if (window.location.hash) {
                var state = void 0;
                if (queryValues.state) {
                    state = queryValues.state;
                }
                if (state) {
                    // Decode the state object to get the query string so the previous form can be loaded again
                    var stateObject = void 0;
                    try {
                        stateObject = JSON.parse(atob(state));
                    }
                    catch (e) {
                        stateObject = undefined;
                    }
                    if (stateObject && stateObject.source === "Skype" && stateObject.search) {
                        window.location.replace(window.location.origin + stateObject.search);
                    }
                }
            }
            // Only run Skype when not in debug mode
            if (!queryValues.debug || queryValues.debug === "false") {
                $.when($dyn.deferred.onTrue(function () {
                    return shouldInitialize();
                })).done(function () {
                    initializeSkype();
                });
            }
        });
        /**
         * Determines if Skype should be initialized
         * @internal
         * @returns A value indicating whether Skype should be initialized
         */
        function shouldInitialize() {
            var user = $dyn.value($dyn.user);
            var retVal = user && $dyn.value(user.Alias) && $dyn.value($dyn.shell.hasRestrictedInternet) === false && $dyn.value(user.SkypeEnabled);
            return retVal ? true : false;
        }
        skypeInteraction.shouldInitialize = shouldInitialize;
        function initializeSkypeLibrary(callback) {
            if (window.Skype) {
                callback();
            }
            else {
                // Load the skype CDN
                var scriptref = document.createElement("script");
                scriptref.setAttribute("type", "text/javascript");
                scriptref.setAttribute("src", Constants.SkypeCDNUrl);
                document.getElementsByTagName("head")[0].appendChild(scriptref);
                scriptref.onload = function () {
                    var startCheckTime = new Date().getTime();
                    var intervalHandle = window.setInterval(function () {
                        if (window.Skype || (new Date().getTime() - startCheckTime) >= 15000) {
                            window.clearTimeout(intervalHandle);
                            callback();
                        }
                    }, 100);
                };
            }
        }
        skypeInteraction.initializeSkypeLibrary = initializeSkypeLibrary;
        /**
         * Initializes the Skype API and attempts to authenticate
         * @internal
         */
        function initializeSkype() {
            initializeSkypeLibrary(function () {
                function authenticationFailed(err) {
                    if (err) {
                        if (isPreProdUser()) {
                            $dyn.log.skype && $dyn.log.skype(err.message);
                        }
                        else {
                            // only do a hard log if we are in a prod environment
                            $dyn.logError(err.message);
                        }
                    }
                    skypeInteraction.authStatus = AuthenticationStatusType.Failed;
                }
                if (!window.Skype) {
                    return;
                }
                if (skypeInteraction.authStatus === AuthenticationStatusType.Unknown) {
                    skypeInteraction.authStatus = AuthenticationStatusType.Authenticating;
                }
                var isAPreProdUser = isPreProdUser();
                var apiKey = isAPreProdUser ? Constants.PreProdApiKey : Constants.ProdApiKey;
                var authParams = skypeInteraction.AuthenticationParams;
                authParams.client_id = getClientId();
                if (isAPreProdUser) {
                    authParams.origins[0] = Constants.PreProdOrigin;
                }
                // Initializes the Skype API
                function initializeSkypeApi() {
                    Skype.initialize({ apiKey: apiKey }, function apiInitialized(api) {
                        window.SkypeWebApp = api.application;
                        skypeInteraction.client = new window.SkypeWebApp();
                        // Log the state when it changes
                        skypeInteraction.client.signInManager.state.changed(function (state) {
                            $dyn.log.skype && $dyn.log.skype("Skype state changed to " + state);
                        });
                        // Sign into Skype
                        skypeInteraction.client.signInManager.signIn(authParams).then(function skypeSignedIn() {
                            skypeInteraction.authStatus = AuthenticationStatusType.Authenticated;
                            $dyn.log.skype && $dyn.log.skype("Signed in as " + skypeInteraction.client.personsAndGroupsManager.mePerson.displayName());
                            // Initialize all subscriptions created before sign-in succeeded
                            // tslint:disable-next-line:forin
                            for (var sipAddress in $dyn.skypeInteraction.subscriptionMap) {
                                var subscription = $dyn.skypeInteraction.subscriptionMap[sipAddress];
                                $dyn.skypeInteraction.initializeSubscription(subscription);
                                subscription.registerSuccessfulSignIn();
                            }
                        }, authenticationFailed);
                    }, authenticationFailed);
                }
                // Create the iframe element we'll use to host the Skype authentication check page
                var skypeAuthenticationCheckFrame = document.createElement("iframe");
                var startCheckTime;
                var intervalHandle;
                // Listens for Skype authentication check messages
                function messageListener(event) {
                    // Only listen for Skype authentication check related messages
                    if (event && event.data && event.data["$dyn-skype-check-type"]) {
                        switch (event.data["$dyn-skype-check-type"]) {
                            case "skype-authenticator-ready-request":
                                // Note: we use a wild card here since the even origin is null (due to sandboxing) and we're
                                // explicitly posting a message to the frame we created
                                skypeAuthenticationCheckFrame.contentWindow.postMessage({
                                    "$dyn-skype-check-type": "skype-authenticator-sign-in-request",
                                    apiKey: apiKey,
                                    configuration: authParams
                                }, "*");
                                // Reset the check time to allow Skype more time to initialize
                                startCheckTime = new Date().getTime();
                                break;
                            case "skype-authentication-sign-in-response":
                                // Message was received, so remove the frame and listener as they're no longer needed
                                document.body.removeChild(skypeAuthenticationCheckFrame);
                                window.removeEventListener("message", messageListener);
                                window.clearInterval(intervalHandle);
                                // Regardless of success, it is safe to initialize (frame didn't redirect to error)
                                initializeSkypeApi();
                                break;
                        }
                    }
                }
                // Add the message listener to facilitate communication with the authentication check frame and configure
                // the Skype authentication check frame.
                window.addEventListener("message", messageListener);
                skypeAuthenticationCheckFrame.style.display = "none";
                // Casting as any as 'sandbox' can be considered readonly
                skypeAuthenticationCheckFrame.sandbox = "allow-scripts allow-same-origin";
                document.body.appendChild(skypeAuthenticationCheckFrame);
                skypeAuthenticationCheckFrame.src = $dyn.shell.rootPath.concat("SkypeAuthenticationCheck.htm");
                // Configure an interval that ensures Skype is authenticated or unloads appropriate resources, and
                // unauthenticates Skype after an appropriate duration (15 seconds)
                startCheckTime = new Date().getTime();
                intervalHandle = window.setInterval(function () {
                    if (new Date().getTime() - startCheckTime >= 15000) {
                        window.clearInterval(intervalHandle);
                        document.body.removeChild(skypeAuthenticationCheckFrame);
                        window.removeEventListener("message", messageListener);
                        authenticationFailed();
                    }
                }, 100);
            });
        }
        skypeInteraction.initializeSkype = initializeSkype;
        /**
         * Returns a value indicating whether the current user is in a pre-production domain
         * @internal
         * @returns A value indicating whether the current user is in a pre-production domain
         */
        function isPreProdUser() {
            return $dyn.value($dyn.value($dyn.user).Alias).endsWith(Constants.PreProdDomain);
        }
        skypeInteraction.isPreProdUser = isPreProdUser;
        /**
         * Returns a value representing the current client ID
         * @internal
         * @returns A value representing the current client ID
         */
        function getClientId() {
            return $dyn.value($dyn.value($dyn.user).ClientId) || Constants.ClientId;
        }
        skypeInteraction.getClientId = getClientId;
        /**
         * Gets a redirect URL to authenticate with O365
         * @internal
         * @returns The redirect URL
         */
        function getRedirectUrl() {
            // Encode the query string as a base-64 string so it can be retrieved after the auth redirect
            var stateObject = {
                search: window.location.search,
                source: "Skype"
            };
            var state = btoa(JSON.stringify(stateObject));
            var isAPreProdUser = isPreProdUser();
            var baseUrl = isAPreProdUser ? Constants.PreProdAuthUrl : Constants.ProdAuthUrl;
            var resource = isAPreProdUser ? Constants.PreProdResource : Constants.ProdResource;
            var redirectLink = baseUrl + "/common/oauth2/authorize?response_type=token&client_id=" + getClientId() + "&redirect_uri=" + window.location.origin + "&state=" + state + "&resource=" + resource;
            return redirectLink;
        }
        skypeInteraction.getRedirectUrl = getRedirectUrl;
        /**
         * Registers the provided presence control and subscribes it to the specified SIP address
         * @internal
         * @param sipAddress The SIP address to associate with the control
         * @param inputControl The input control to register
         */
        function registerControl(sipAddress, inputControl) {
            // Do nothing if the Skype API does not exist
            if (!window.Skype) {
                return;
            }
            $dyn.setValue(inputControl, "Presence", PresenceType.Unknown);
            function performRegistration() {
                var presenceElement = inputControl.$cachedElement.find(".skype-presenceBox");
                var qtip;
                var qtipControl;
                var presenceContainer;
                if (presenceElement.length === 0) {
                    if (skypeInteraction.presenceIndicatorTemplate === undefined) {
                        skypeInteraction.presenceIndicatorTemplate = $($dyn._getTemplate("PresenceIndicator"));
                    }
                    presenceContainer = skypeInteraction.presenceIndicatorTemplate.clone();
                    presenceElement = presenceContainer.find(".skype-presenceBox");
                    presenceContainer.insertBefore(inputControl.$inputElement);
                    var qtipPlaceholder = $("<div></div>");
                    qtip = addQtip(presenceContainer, qtipPlaceholder);
                    qtipControl = React && ReactDOM.render(React.createElement($dyn.DynReact.UI.SkypeContactCard, {
                        Authenticated: skypeInteraction.authStatus === AuthenticationStatusType.Authenticated,
                        SipAddress: sipAddress,
                        ToggleQtip: createQtipCloseHandler(qtip, inputControl),
                    }), getQtipContent(qtip)[0]);
                    qtip.set("events.visible", function () {
                        var content = getQtipContent(qtip);
                        var signInLink = content.find("skype-signInLink");
                        if (signInLink.length > 0) {
                            signInLink.focus();
                        }
                        else {
                            var emailButton = content.find("#emailButton");
                            if (emailButton.length > 0) {
                                emailButton.focus();
                            }
                        }
                    });
                }
                var subscription = $dyn.skypeInteraction.subscriptionMap[sipAddress];
                var isNewSubscription = subscription === undefined;
                var isNewControl = true;
                if (isNewSubscription) {
                    subscription = new $dyn.skypeInteraction.PresenceSubscription(sipAddress);
                    $dyn.skypeInteraction.subscriptionMap[sipAddress] = subscription;
                }
                else {
                    // tslint:disable-next-line:forin
                    for (var controlIndex in subscription.controls) {
                        var control = subscription.controls[controlIndex];
                        if (control.inputControl === inputControl) {
                            isNewControl = false;
                            break;
                        }
                    }
                }
                if (isNewControl) {
                    subscription.controls.push(new PresenceControl(inputControl, presenceElement, presenceContainer, qtip, qtipControl));
                }
                subscription.refresh();
                if (isNewSubscription && skypeInteraction.authStatus === AuthenticationStatusType.Authenticated) {
                    $dyn.skypeInteraction.initializeSubscription(subscription);
                }
            }
            if (!$dyn.value(inputControl.Root.IsInViewMode)) {
                // If the form is in edit mode, cache the registration to be processed later
                cacheRegistration(sipAddress, inputControl);
            }
            else {
                performRegistration();
            }
        }
        skypeInteraction.registerControl = registerControl;
        /**
         * Adds a qtip to the target element using the provided content
         * @internal
         * @param targetElement The target element of the qtip
         * @param content The content to add to the qtip
         * @returns The created qtip
         */
        function addQtip(targetElement, content) {
            return targetElement.qtip({
                content: { text: content },
                events: {
                    visible: function () {
                        if (targetElement) {
                            targetElement.focus();
                        }
                    }
                },
                hide: { delay: 200, fixed: true, event: "unfocus mouseout" },
                show: "click mouseover",
                style: { classes: "qtip-light qtip-shadow" },
            }).qtip("api");
        }
        skypeInteraction.addQtip = addQtip;
        /**
         * Initializes the provided subscription with the Skype API
         * @internal
         * @param subscription The subscription to initialize
         */
        function initializeSubscription(subscription) {
            if (skypeInteraction.client) {
                try {
                    var personSearch_1 = skypeInteraction.client.personsAndGroupsManager.createPersonSearchQuery();
                    if (subscription.sipAddress) {
                        personSearch_1.text(subscription.sipAddress);
                        personSearch_1.limit(1);
                        personSearch_1.getMore().then(function () {
                            var results = personSearch_1.results();
                            if (results.length === 0 || results[0].result.id._value.indexOf(subscription.sipAddress) === -1) {
                                throw new Error("SIP address not found");
                            }
                            return results[0].result;
                        }, function () {
                            $dyn.log.skype && $dyn.log.skype("Contact not found: " + subscription.sipAddress);
                            subscription.completeInitialization();
                        }).then(function (contact) {
                            $dyn.log.skype && $dyn.log.skype("Contact found: " + subscription.sipAddress);
                            contact.status.get().then(subscription.onPresenceChanged);
                            contact.status.changed(subscription.onPresenceChanged);
                            // The 4 expected properties: display name, work phone, title, and avatar URL
                            var expectedPropertiesRetrieved = 4;
                            var propertiesRetrieved = 0;
                            function incrementRetrievedProperties() {
                                propertiesRetrieved++;
                                if (propertiesRetrieved === expectedPropertiesRetrieved) {
                                    subscription.completeInitialization();
                                }
                            }
                            contact.displayName.get().then(function (displayName) {
                                subscription.contactName = displayName;
                                incrementRetrievedProperties();
                            });
                            contact.workPhone.get().then(function (workPhone) {
                                subscription.contactPhone = workPhone;
                                incrementRetrievedProperties();
                            });
                            contact.title.get().then(function (title) {
                                subscription.contactTitle = title;
                                incrementRetrievedProperties();
                            });
                            contact.avatarUrl.get().then(function (avatarUrl) {
                                subscription.avatarUrl = avatarUrl;
                                incrementRetrievedProperties();
                            });
                            subscription.contact = contact;
                            subscription.subscriptionObject = contact.status.subscribe();
                        }, function subscriptionFailed() {
                            $dyn.log.skype && $dyn.log.skype("Could not subscribe to presence value for Skype interaction");
                        });
                    }
                    else {
                        $dyn.log.skype && $dyn.log.skype("No SIP address present on subscription for Skype interaction");
                        subscription.completeInitialization();
                    }
                }
                catch (e) {
                    $dyn.log.skype && $dyn.log.skype("Error encountered while interacting with Skype SDK");
                    subscription.completeInitialization();
                }
            }
            else {
                subscription.completeInitialization();
            }
        }
        skypeInteraction.initializeSubscription = initializeSubscription;
        /**
         * Unregisters the provided control and destroys the attached presence element
         * @internal
         * @param sipAddress The SIP address of the control to unregister
         * @param inputControl The input control to unregister
         */
        function unregisterControl(sipAddress, inputControl) {
            var controlUnregistered = false;
            var subscription = $dyn.skypeInteraction.subscriptionMap[sipAddress];
            if (subscription) {
                // tslint:disable-next-line:forin
                for (var controlIndex in subscription.controls) {
                    var subscribedControl = subscription.controls[controlIndex];
                    if (subscribedControl.inputControl === inputControl) {
                        if (subscribedControl.qtip && subscribedControl.qtipControl) {
                            var containerElement = getQtipContent(subscribedControl.qtip)[0];
                            if (containerElement) {
                                ReactDOM.unmountComponentAtNode(containerElement);
                            }
                        }
                        if (subscribedControl.qtip !== undefined) {
                            subscribedControl.qtip.destroy(true);
                        }
                        subscribedControl.inputControl.$cachedElement.removeClass("skype-presenceInput");
                        subscribedControl.presenceContainer.remove();
                        subscription.controls.splice(controlIndex, 1);
                        controlUnregistered = true;
                        break;
                    }
                }
                if (subscription.controls.length === 0) {
                    if (subscription.subscriptionObject !== undefined) {
                        subscription.subscriptionObject.dispose();
                    }
                    delete $dyn.skypeInteraction.subscriptionMap[sipAddress];
                }
            }
            // If no control was found to unregister, attempt to remove it from the cache
            if (!controlUnregistered) {
                $dyn.skypeInteraction.removeCachedRegistration(sipAddress, inputControl);
            }
        }
        skypeInteraction.unregisterControl = unregisterControl;
        /**
         * Unregisters all subscribed Skype controls
         * @internal
         */
        function unregisterAllControls() {
            // tslint:disable-next-line:forin
            for (var sipAddress in $dyn.skypeInteraction.subscriptionMap) {
                var subscription = $dyn.skypeInteraction.subscriptionMap[sipAddress];
                while (subscription.controls.length > 0) {
                    unregisterControl(subscription.sipAddress, subscription.controls[0].inputControl);
                }
            }
            $dyn.skypeInteraction.subscriptionMap = {};
        }
        skypeInteraction.unregisterAllControls = unregisterAllControls;
        /**
         * Caches the provided registration information to be processed later
         * @internal
         * @param sipAddress The SIP address
         * @param inputControl The input control
         */
        function cacheRegistration(sipAddress, inputControl) {
            var controlArray = $dyn.skypeInteraction.cachedRegistrationMap[sipAddress];
            if (controlArray === undefined) {
                controlArray = [inputControl];
                $dyn.skypeInteraction.cachedRegistrationMap[sipAddress] = controlArray;
            }
            else {
                var enqueue = true;
                for (var controlIndex in controlArray) {
                    if (controlArray[controlIndex] === inputControl) {
                        enqueue = false;
                        break;
                    }
                }
                if (enqueue) {
                    controlArray.push(inputControl);
                }
            }
        }
        skypeInteraction.cacheRegistration = cacheRegistration;
        /**
         * Removes the cached registration matching the specified SIP address and input control
         * @internal
         * @param sipAddress The SIP address of the cached registration to remove
         * @param inputControl The input control of the cached registration to remove
         */
        function removeCachedRegistration(sipAddress, inputControl) {
            var controlArray = $dyn.skypeInteraction.cachedRegistrationMap[sipAddress];
            if (controlArray !== undefined) {
                for (var controlIndex in controlArray) {
                    if (controlArray[controlIndex] === inputControl) {
                        controlArray.splice(controlIndex, 1);
                        break;
                    }
                }
                if (controlArray.length === 0) {
                    delete $dyn.skypeInteraction.cachedRegistrationMap[sipAddress];
                }
            }
        }
        skypeInteraction.removeCachedRegistration = removeCachedRegistration;
        /**
         * Adds all currently registred controls to the registration cache
         * @internal
         */
        function cacheRegisteredControls() {
            var _loop_1 = function (sipAddress) {
                var subscription = $dyn.skypeInteraction.subscriptionMap[sipAddress];
                if (subscription) {
                    subscription.controls.forEach(function (control) {
                        cacheRegistration(sipAddress, control.inputControl);
                    });
                }
            };
            // tslint:disable-next-line:forin
            for (var sipAddress in $dyn.skypeInteraction.subscriptionMap) {
                _loop_1(sipAddress);
            }
        }
        skypeInteraction.cacheRegisteredControls = cacheRegisteredControls;
        /**
         * Registers all cached registration information and clears the registration cache
         * @internal
         */
        function processRegistrationCache() {
            // Do nothing if the Skype API does not exist
            if (!window.Skype) {
                return;
            }
            var _loop_2 = function (sipAddress) {
                var controlArray = $dyn.skypeInteraction.cachedRegistrationMap[sipAddress] || [];
                controlArray.forEach(function (control) {
                    registerControl(sipAddress, control);
                });
            };
            // tslint:disable-next-line:forin
            for (var sipAddress in $dyn.skypeInteraction.cachedRegistrationMap) {
                _loop_2(sipAddress);
            }
            $dyn.skypeInteraction.cachedRegistrationMap = {};
        }
        skypeInteraction.processRegistrationCache = processRegistrationCache;
        /**
         * Gets the jQuery control content for the provided qtip.
         * @internal
         * @param qtip The qtip with content to retrieve.
         * @returns The jQuery control.
         */
        function getQtipContent(qtip) {
            var qtipContent = qtip.get("content.text");
            if (qtipContent.length === undefined && qtipContent.target !== undefined && qtipContent.target.length > 0) {
                qtipContent = qtipContent.target;
            }
            return qtipContent;
        }
        skypeInteraction.getQtipContent = getQtipContent;
    })(skypeInteraction = $dyn.skypeInteraction || ($dyn.skypeInteraction = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=skype-interaction.js.map
